// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export const SMS_TEXT: string = 'SMS';
export const STANDARD_TEXT: string = 'Standard';
